<template>
    <div class="page page--activities activities">
        <div class="cta">
            <div class="cta__content">
            </div>
        </div>
        <div class="page__content">
            <div class="page__content__block">
                <div>
                    <h1>{{$t('activities.title')}}</h1>
                </div>
                <div v-html="$t('activities.text')"></div>
            </div>
        </div>
        <div class="page__content">
            <div class="home__blocks">
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.fatbike.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/ebike.jpg" alt="e-fatbiken">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.fatbike.text')"></div>
                </div>

                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.fish.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/ijsvissen.jpeg" alt="ijsvissen">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.fish.text')"></div>
                </div>

                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.snowmobile.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/sneeuwscooter.jpg" alt="sneeuwscooter">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.snowmobile.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.borealis.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/noorderlicht.jpg" alt="Aurora Borealis">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.borealis.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.husky.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/husky.jpg" alt="Husky slee">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.husky.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.reindeer.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/rendier.jpg" alt="Rendier safari">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.reindeer.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.icefloating.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/if.jpg" alt="Ice floating">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.icefloating.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.snowshoe.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/sschoen.jpg" alt="Sneeuwschoenen">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.snowshoe.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.sauna.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/home/uitbaters.jpg" alt="Husky slee">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.sauna.text')"></div>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('activities.games.title')}}</div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/activities/diploma.jpg" alt="Rendier safari">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('activities.games.text')"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Activities"
    }
</script>